import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { emailFormatRegEx } from '@proximus/ng-common';
import { PasswordRecoveryManagementValidator } from '../../validators/password-recovery-management.validator';

@Component({
  selector: 'mprd-email-submit',
  templateUrl: 'email-submit.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmailSubmitComponent implements OnInit {
  emailSubmitForm: UntypedFormGroup;
  isEmailFormHasErrors: boolean;
  @Output() validEmailSubmit: EventEmitter<any> = new EventEmitter();
  @Output() emailSubmitCancel: EventEmitter<any> = new EventEmitter();

  constructor(
    private builder: UntypedFormBuilder,
    private changeDetector: ChangeDetectorRef,
    private passwordRecoveryManagementValidator: PasswordRecoveryManagementValidator,
  ) {}

  ngOnInit() {
    this.emailSubmitForm = this.builder.group({
      emailId: [
        '',
        [
          Validators.required,
          Validators.pattern(emailFormatRegEx),
          this.passwordRecoveryManagementValidator.checkForbiddenRecoveryEmailValues(),
        ],
      ],
    });
    this.emailSubmitForm.valueChanges.subscribe((value) => {
      this.isEmailFormHasErrors =
        this.emailSubmitForm.get('emailId').dirty &&
        !this.emailSubmitForm.pending &&
        !this.emailSubmitForm.get('emailId').valid;
    });
  }

  emitEmail() {
    this.validEmailSubmit.emit(this.emailSubmitForm.get('emailId').value);
  }

  onEmailSubmitCancel() {
    this.emailSubmitCancel.emit({});
  }

  isMailEmpty() {
    return this.emailSubmitForm.value.emailId?.length === 0;
  }
}
